import { resolveMarketLink } from '../modules/marketUri';

document.body.addEventListener('jb-link:initialized', (event: Event) => {
  if (!(event instanceof CustomEvent)) {
    return;
  }
  const { linkTag } = event.detail as { linkTag: unknown };
  if (!(linkTag instanceof HTMLAnchorElement)) {
    return;
  }
  resolveMarketLink(linkTag);
});

window.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll<HTMLAnchorElement>('a[data-market-uris]').forEach(resolveMarketLink);
});
